import { useState } from "react";
import AddDepartment from "./AddDepartment";
import { useSelector } from "react-redux";

const DepartmentMasterData = ({ searchTerm, sortConfig }) => {
    const [selectedRow, setSelectedRow] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [operation, setOperation] = useState();
    const loading = useSelector((state) => state.teammanagement.loading);
    const error = useSelector((state) => state.teammanagement.error);
    const departmentData = useSelector((state) => state.teammanagement.data.department);

    if (loading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        );
    }

    const handleRowClick = (row) => {
        setSelectedRow(row);
        setShowOffcanvas(!showOffcanvas);
        setOperation("update");
    };

    const filteredData = departmentData.results
        ? departmentData.results.filter((curData) => {
            const { id, department_name, description, status } = curData;
            return (
                id?.toString().includes(searchTerm) ||
                department_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (status ? 'active' : 'inactive').toLowerCase().includes(searchTerm.toLowerCase())
            );
        })
        : [];

    const sortedData = filteredData.sort((a, b) => {
        if (sortConfig.key) {
            const order = sortConfig.direction === 'asc' ? 1 : -1;
            return a[sortConfig.key] > b[sortConfig.key] ? order : -order;
        }
        return 0;
    });

    return (
        <>
            {sortedData.length > 0 ? (
                sortedData.map((curData) => {
                    const { id, department_name, description, status } = curData;

                    return (
                        <tr
                            key={id}
                            onClick={() => handleRowClick(curData)}
                            className={`clickable ${selectedRow.id === id ? 'selected' : ''}`}
                        >
                            <td>{id}</td>
                            <td>{department_name}</td>
                            <td>{description}</td>
                            <td style={{ color: "green",paddingLeft:"50px" }}>
                                <span><b>{status ? 'Active' : 'Inactive'}</b></span>
                            </td>
                            <td></td>
                        </tr>
                    );
                })
            ) : (
                <p>No department data available.</p>
            )}
            <AddDepartment
                selectedRow={selectedRow}
                setShowOffcanvas={setShowOffcanvas}
                showOffcanvas={showOffcanvas}
                setSelectedRow={setSelectedRow}
                operation={operation}
            />
        </>
    );
};

export default DepartmentMasterData;